import React from "react";
var __jsx = React.createElement;
/* eslint-disable */

// ******************************* User Feature Entitlements Mechanism ******************************* //
// 1. withFeatureEntitlements: HOW Wrapper Component
// 2. checkFeatureEntitlement: function that checks if user is entitled to a feature
// *************************************************************************************************** //

import { useEffect, useState } from "react";
import { useRouter } from "next/router";
import { useSelector } from "react-redux";
import { selectUsersession } from "redux/reducers/userSessionReducer";
export var withFeatureEntitlements = function withFeatureEntitlements(WrappedComponent, featureName) {
  return function (props) {
    var router = useRouter();
    var _useSelector = useSelector(selectUsersession),
      userSessionData = _useSelector.data,
      userSessionStatus = _useSelector.status;
    var _useState = useState(false),
      status = _useState[0],
      setStatus = _useState[1];
    useEffect(function () {
      var _userSessionData$user;
      if (!userSessionData || userSessionStatus !== "done") return undefined;
      var entitlements = userSessionData === null || userSessionData === void 0 ? void 0 : (_userSessionData$user = userSessionData.userEntitlements) === null || _userSessionData$user === void 0 ? void 0 : _userSessionData$user.filter(function (entitlement) {
        return entitlement.entitlementType === "FEATURE" && entitlement.name === featureName;
      });
      var featureStatus = (entitlements === null || entitlements === void 0 ? void 0 : entitlements.length) === 1 && entitlements[0].name === featureName;
      featureStatus ? setStatus(featureStatus) : router.replace("/");
    }, [featureName, userSessionData]);
    if (!featureName) {
      return null;
    }
    if (status) return /*#__PURE__*/React.createElement(WrappedComponent, props);
  };
};
export var checkFeatureEntitlement = function checkFeatureEntitlement(featureName) {
  var _useSelector2 = useSelector(selectUsersession),
    userSessionData = _useSelector2.data,
    userSessionStatus = _useSelector2.status;
  if (!userSessionData || userSessionStatus !== "done") return undefined;
  var entitlements = userSessionData === null || userSessionData === void 0 ? void 0 : userSessionData.userEntitlements.filter(function (entitlement) {
    return entitlement.entitlementType === "FEATURE" && entitlement.name === featureName;
  });
  var featureStatus = (entitlements === null || entitlements === void 0 ? void 0 : entitlements.length) === 1 && entitlements[0].name === featureName;
  return featureStatus;
};